import { Resource } from '@features/resources/types';
import { Icon } from '@features/ui/components';
import classNames from 'classnames';

type ResourceCardProps = {
  resource: Resource;
};

export const ResourceCard = ({ resource }: ResourceCardProps): JSX.Element => (
  <a
    className="min-h-32 relative flex cursor-pointer flex-col border border-gray-100 py-5 px-7 hover:bg-gray-100"
    target="_blank"
    href={resource.url}
    rel="noreferrer"
  >
    {}
    <TypeIcon type={resource.type} />
    <span className="text-brand-black block pt-4">{resource.title}</span>
    <Icon icon="arrowUp" className="text-primary absolute top-5 right-7 h-6 w-6 rotate-45" />
  </a>
);

const TypeIcon = ({ type }: { type: Resource['type'] }) => {
  const colors = type === 'pdf' ? 'text-red-600 bg-red-50' : 'text-sky-500 bg-sky-50';

  return (
    <div className={classNames('grid h-12 w-12 place-items-center rounded-lg', colors)}>
      <Icon icon={type === 'pdf' ? 'filePdf' : 'link'} className="h-5 w-5" />
    </div>
  );
};
